import { render, staticRenderFns } from "./BingeDrinkerWarning.vue?vue&type=template&id=69fab610&scoped=true&"
import script from "./BingeDrinkerWarning.vue?vue&type=script&lang=js&"
export * from "./BingeDrinkerWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fab610",
  null
  
)

export default component.exports